import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";

export const sendCertififcateApi = createAsyncThunk(
  "user/sendCetificate",
  async (data) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/send-certificate`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => {
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const sendCertificateToStudentSlicer = createSlice({
  name: "Send Certificate To Studnet",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(sendCertififcateApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendCertififcateApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Data Send Successfuly") {
        state.data = action.payload.data;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(sendCertififcateApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default sendCertificateToStudentSlicer.reducer;
